// Darstellungsfehler Cookie Einstellungen anpassen
$(document).ready(function(){
  $(document).on("click", "#banner-wrapper .btn-manage", function(){
    $("#banner-wrapper .tabs").css("display","block");
  });
  
  $(document).on("blur", ".header-controls__search-field", function() {
  	window.scrollTo(window.scrollX, window.scrollY - 1);
	window.scrollTo(window.scrollX, window.scrollY + 1);
  })
});

// Trigger Scrollevent
window.scrollTo(window.scrollX, window.scrollY - 1);
window.scrollTo(window.scrollX, window.scrollY + 1);